import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import toastr from "toastr";


class ModalViewExitImage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    console.log("this.props: ",this.props);
    return (
      <Modal
        bsSize="medium"
        show={this.props.open} onHide={this.props.closeViewImage}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.employee.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <object data={this.props.employee.imageUrl} type="application/pdf" height="400px" width="400px" border={0}></object>
          </div>
          <br/>
          <button
            className="btn btn-default btn-block"
            onClick={()=> {
              this.props.closeViewImage();
            }}
          >Close
          </button>
        </Modal.Body>
      </Modal>
    );
  }
}

ModalViewExitImage.propTypes = {};

export default ModalViewExitImage;



/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Exit/ModalViewExitImage.js
 **/